import React from "react";
import {
  Select,
  SelectOption,
  Control,
  SelectOptionSearch,
} from "@forge/common";

interface SearchableSelectProps {
  data: Array<{ value: string; text: string }>;
  selectedIndex?: number;
  searchTerm: string;
  placeholder: string;
  ariaLabel: string;
  id: string;
  testId: string;
  className: string;
  controlClassName: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  defaultValue?: string | string[];
  multiple?: boolean;
  canSelectAll?: boolean;
  searchable?: boolean;
  onChange: (value: string) => void;
  onSearchChange?: (value: string) => void;
  onBlur?: () => void;
}

const SearchableSelectDropDown: React.FC<SearchableSelectProps> = ({
  data,
  selectedIndex = 0,
  searchTerm,
  placeholder,
  ariaLabel,
  id,
  testId,
  className,
  controlClassName,
  disabled = false,
  style,
  defaultValue,
  multiple,
  canSelectAll,
  searchable = true,
  onChange,
  onSearchChange,
  onBlur,
}) => {
  const CONTROL_STYLE = { minWidth: "max-content", ...style };
  const SELECT_SIZE = "regular";
  const SEARCH_LABEL = "Search";
  const SEARCH_PLACEHOLDER = "Search";
  const OPTION_CLASS_NAME = "custom-select-option";
  const OPTION_STYLE = { minWidth: "max-content" };

  const handleSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement> | any,
  ) => (!multiple ? onChange(event.target.value) : onChange(event));
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    onSearchChange?.(event.target.value);

  const filteredData = data.filter((option: any) => {
    const optionText =
      option && typeof option.text === "string" ? option.text : "";
    const search = typeof searchTerm === "string" ? searchTerm : "";
    return optionText.toLowerCase().includes(search.toLowerCase());
  });
  const selectModeProps = multiple
    ? { multiple: true as const, canSelectAll: !!canSelectAll }
    : {};

  return (
    <Control className={controlClassName} style={CONTROL_STYLE}>
      <Select
        aria-label={ariaLabel}
        id={id}
        data-testid={testId}
        key={`${id}-${selectedIndex}-${data[selectedIndex]?.value}`}
        defaultValue={defaultValue ?? data[selectedIndex]?.text}
        placeholder={placeholder}
        onChange={handleSelectChange}
        onBlur={onBlur}
        disabled={disabled}
        size={SELECT_SIZE}
        className={className}
        {...(searchable && {
          search: (
            <SelectOptionSearch
              label={SEARCH_LABEL}
              placeholder={SEARCH_PLACEHOLDER}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          ),
        })}
        {...selectModeProps}
      >
        {filteredData.map((option: any) => (
          <SelectOption
            key={option.value}
            value={option.text}
            label={option.text}
            className={OPTION_CLASS_NAME}
            style={OPTION_STYLE}
          >
            {option.text}
          </SelectOption>
        ))}
      </Select>
    </Control>
  );
};

export default SearchableSelectDropDown;
